/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs */

const en_cv_extract_form_enum_mechanical_engineering21 = /** @type {(inputs: Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mechanical Engineering`)
};

const de_cv_extract_form_enum_mechanical_engineering21 = /** @type {(inputs: Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschinenbau`)
};

/**
* | output |
* | --- |
* | "Mechanical Engineering" |
*
* @param {Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_mechanical_engineering21 = /** @type {((inputs?: Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Mechanical_Engineering21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_mechanical_engineering21(inputs)
	return en_cv_extract_form_enum_mechanical_engineering21(inputs)
});
export { cv_extract_form_enum_mechanical_engineering21 as "cv_extract_form_enum_MECHANICAL_ENGINEERING" }